import { api } from './client';

export type UserRole = 'OPERATOR' | 'GUEST' | 'UNKNOWN';

export interface MeResponse {
  username: string | null;
  authenticated: boolean;
  role: UserRole | null;
}

export const authApi = {
  me: () => api<MeResponse>('/api/auth/me'),
  login: (username: string, password: string) =>
    api<MeResponse>('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    }),
  logout: () => api<void>('/api/auth/logout', { method: 'POST' }),
};
